import { StockStatuses } from '@dcxwam/dcx-wam-ui-foundations'
import { StockLevelStatus } from '../../../services/stock'
import { ShopConfig } from './config'

export const getStockInfoLabel = (props: {
  isSsr: boolean
  stockLevelStatus: string
  shopConfig: ShopConfig
}) => {
  const { isSsr, stockLevelStatus, shopConfig } = props
  let stockLabel: string | undefined = '&nbsp;' // Default value to keep the line and avoid CLS
  switch (!isSsr && stockLevelStatus) {
    case StockLevelStatus.inStock:
      stockLabel = shopConfig?.inStockLabel
      break
    case StockLevelStatus.outOfStock:
      stockLabel = shopConfig?.outOfStockLabel
      break
    case StockLevelStatus.lowStock:
      stockLabel = shopConfig?.lowStockLabel
      break
    default:
      break
  }
  return stockLabel
}

export const getEffectiveStockLevelStatus = (
  stockLevelStatus: string,
  minQuantityExceedsStock: boolean
): string => {
  if (minQuantityExceedsStock) {
    return StockLevelStatus.outOfStock
  }
  return stockLevelStatus
}

export const shouldStockMessageBeShown = ({
  showStockLevel,
  shopConfigStockEnabled,
  productStockStatus
}: {
  showStockLevel: boolean
  shopConfigStockEnabled?: boolean
  productStockStatus?: StockStatuses
}) => {
  const isInStock = productStockStatus === StockStatuses.InStock
  if (shopConfigStockEnabled && showStockLevel && isInStock) {
    return true
  }
  if (!isInStock && showStockLevel) {
    return true
  }
  return false
}
